import type { GetUserNotificationPreferencesQuery } from './graphql/GetUserNotificationPreferences.generated';

// ─────────────────────────────────────────────────────────────────────

export enum NotificationCategoryType {
  Marketing = 'marketing',
  OrderStatus = 'order-status',
}

export type NotificationCategory = Extract<
  GetUserNotificationPreferencesQuery['getUserNotificationPreferences'],
  { __typename: 'UserNotificationPreferences' }
>['notificationCategories'][number];

export type NotificationCategories = Omit<NotificationCategory, '__typename'>[];
